import React from "react";
import { Link } from "react-router-dom";
import { FACE_LINK, ZALO_LINK } from "../../common/variable";
import { scrollToForm } from "../../utils/Validate";

const Header = () => {
  return (
    <>
      <div
        className="container-fluid bg-primary text-white d-none d-lg-flex"
        id="headerDiv"
      >
        <div className="container py-3">
          <div className="d-flex align-items-center">
            <img
              src="/shinhan-finance.png"
              className="btn btn-sm-square ms-2 p-0 rounded-circle"
            />
            <Link to="/" className="decoration-none">
              <h2 className="text-white fw-bold m-0">Shinhan Finance</h2>
            </Link>
            <div className="ms-auto d-flex align-items-center">
              <small className="ms-4">
                <i className="fa fa-map-marker-alt me-3"></i>
                <a
                  href="https://maps.app.goo.gl/pqdaMuLwYWjFVZHu5"
                  target="_blank"
                  className="text-white no-underline-link"
                >
                  271 Nguyễn Văn Linh, Thanh Khê, Đà Nẵng
                </a>
              </small>
              <small className="ms-4">
                <i className="fa fa-phone-alt me-3"></i>
                <a
                  href="tel::0838598518"
                  className="text-white no-underline-link"
                >
                  0838598518
                </a>
              </small>
              <div className="ms-3 d-flex">
                <a
                  className="btn btn-sm-square btn-light text-primary rounded-circle ms-2"
                  href={FACE_LINK}
                  target="_blank"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-sm-square ms-2 p-0"
                  href={ZALO_LINK}
                  target="_blank"
                >
                  <img src="/img/icon/zalo-icon.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-white sticky-top">
        <div className="container">
          <nav className="navbar navbar-expand-lg bg-white navbar-light p-lg-0">
            <span className="navbar-brand d-lg-none fw-bold m-0 d-flex align-items-center">
              <img
                src="/shinhan-finance.png"
                className="btn btn-sm-square ms-2 p-0"
              />
              Shinhan Finance
            </span>
            <button
              type="button"
              className="navbar-toggler me-0"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div className="navbar-nav">
                <a href="/" className="nav-item nav-link active">
                  Trang chủ
                </a>
                <a href="/policy" className="nav-item nav-link">
                  Điều kiện vay
                </a>
                <div className="nav-item dropdown">
                  <a
                    href="#"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Chính sách và điều khoản
                  </a>
                  <div className="dropdown-menu bg-light rounded-0 rounded-bottom m-0">
                    <a href="/code-of-conduct" className="dropdown-item">
                      Quy tắc ứng xử
                    </a>
                    <a href="/policy" className="dropdown-item">
                      Chính sách bảo mật
                    </a>
                    <a href="/disclaimer" className="dropdown-item">
                      Miễn trừ trách nhiệm
                    </a>
                  </div>
                </div>
                <a href="/contact-us" className="nav-item nav-link">
                  liên hệ
                </a>
              </div>
              <div className="ms-auto d-none d-lg-block">
                <span
                  className="btn btn-primary rounded-pill py-2 px-3"
                  onClick={() => scrollToForm()}
                >
                  Vay nhanh
                </span>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
